
import * as L from 'leaflet';

//todo need add a little more marker types
export const markerIcons       = {
    default:  L.icon({
        iconUrl: '/images/marker/marker-icon-blue.png',
        iconRetinaUrl: '/images/marker/marker-icon-blue-2x.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowUrl: '/images/marker/marker-shadow.png',
        shadowSize: [41, 41],
    }),
    blue:  L.icon({
        iconUrl: '/images/marker/marker-icon-blue.png',
        iconRetinaUrl: '/images/marker/marker-icon-blue-2x.png',
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        popupAnchor: [1, -34],
//        tooltipAnchor: [16, -28],
        shadowUrl: '/images/marker/marker-shadow.png',
        shadowSize: [41, 41],
        className: 'blink-marker',
    }),
    green: L.icon({
        iconUrl: '/images/marker/marker-icon-green.png',
        iconRetinaUrl: '/images/marker/marker-icon-green-2x.png',
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        popupAnchor: [1, -34],
//        tooltipAnchor: [16, -28],
        shadowUrl: '/images/marker/marker-shadow.png',
        shadowSize: [41, 41],
        className: 'blink-marker',
    }),
    sonar: L.divIcon({
        className: 'sonar-wrapper',
        iconSize: [100, 100],
        iconAnchor: [56, 57],
        tooltipAnchor: [0, 20],
        pmIgnore: true, //deny editing operations by geoman drawing
        html: '<div class="sonar-emitter"></div>'
    })
};

// sets default lealfet marker icon to our blue marker
L.Marker.prototype.options.icon = markerIcons.default;

class markerFactory {
    constructor(mapLayer) {
        this.map = mapLayer;
        this.markers =  new Map();
    }

    //position - L.latLng object
    //lifetime in sec
    AddMarker(position, iconName, lifetime, id) {
        let markerId = id || this._uuidv4();
        let marker = this.markers.get(markerId)
        if (marker) {
            marker.setLatLng(position)
            return marker;
        }
        marker = L.marker( position, {icon: markerIcons[iconName]} );
        marker._mf_uid = id

        this.markers.set( markerId, marker);

        if (position)
            marker.addTo(this.map);

        if (lifetime) {
            setTimeout(function () {
                this.RemoveMarker(markerId);
            }.bind(this), 1000 * lifetime)
        }
        return marker
    }

    GetMarker(id) {
        return this.markers.get(id)
    }

    RemoveMarker(id) {
        let marker = this.markers.get(id);
        if (marker == null)
            return;
        marker.remove();
        //todo here we need to remove a timer if it's defined, but we rely on it will be destroyed correctly on timeout
        this.markers.delete(id)
    }

    //simple uid generator, it's enough to our purpose
    _uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

export {markerFactory};
